import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function usePayoutReportEdit() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ payoutReport }) => apiCalls.editPayoutReport({ payoutReport }), {
    onSuccess: () => {
      queryClient.invalidateQueries('payoutReports');
    },
  });
  return { editPayoutReport: mutate, ...rest };
}

export function usePayoutReportsEdit() {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(
    async ({ payoutReports }) => {
      return await payoutReports.forEach(async (payoutReport) => {
        await apiCalls.editPayoutReport({
          payoutReport: { ...payoutReport, status: payoutReport.status === 'PAID' ? 'NOT_PAID' : 'PAID' },
        });
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('payoutReports');
      },
    }
  );
  return { editPayoutReports: mutate, ...rest };
}

export function usePayoutReports(params) {
  const { data, ...rest } = useQuery('payoutReports', () =>
    apiCalls.getPayoutReports(params).then(({ data: { payoutReports, totalCount } }) => ({
      payoutReports,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}
